module.exports = __webpack_public_path__ + "static/media/banner.f2a0fafc.png";